import { render } from "./PlanManagementHub.vue?vue&type=template&id=4ec0048a&scoped=true"
import script from "./PlanManagementHub.vue?vue&type=script&lang=js"
export * from "./PlanManagementHub.vue?vue&type=script&lang=js"

import "./PlanManagementHub.vue?vue&type=style&index=0&id=4ec0048a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec0048a"]])

export default __exports__